import { connect } from 'react-redux';
import { msg } from 'api';

import { isUserLoggedIn } from 'apps/user/helpers';
import { withMediaQueryDesktop } from 'utils/mediaQueries/withMediaQueries';

import { reportTopTabClicked } from 'apps/header/actions/topTabs';
import { openMobileNav, closeMobileNav } from 'apps/topNavigation/actions/topNavigation';

import Header from '../components/Header';

import brandLogo from 'themes/[theme]/assets/images/brand-logo.png'; // eslint-disable-line import/order

export default connect(
  state => ({
    betaFeatures: state.user.betaFeatures,
    isLoggedIn: isUserLoggedIn(state.user),
    mobileNavOpened: state.topNavigation.mobileNavigationOpened,
    logo: getDesktopLogo(state),
  }),
  {
    openMobileNav,
    closeMobileNav,
    reportTopTabClicked,
  }
)(withMediaQueryDesktop(Header));

function getDesktopLogo(state) {
  const { headerLogo } = state.logosFromScribe;
  const shouldUseScribeLogo = state.user.betaFeatures.includes('SCRIBE_LOGO');

  const defaultLogo = {
    image: brandLogo,
    altText: msg.admin.header.logoAlt,
    url: '/webshop/startWebshop.do',
  };

  if (!headerLogo || !headerLogo.image) return defaultLogo;

  const scribeLogo = { ...headerLogo };

  return shouldUseScribeLogo ? scribeLogo : defaultLogo;
}
